import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit {


  constructor(private route: ActivatedRoute,
    private authService: AuthService, private router: Router) {

  }

  ngOnInit(): void {
    this.authService.showAuthControls.set(false);
  }

  navigateToForm() {
    this.router.navigate(['dform']);
  }

}
